<template>
  <div>
    <div
      v-if="data.column.field === 'propertyName'"
      class="d-flex align-items-center"
    >
      <span>{{ data.row.propertyName }}</span>
    </div>
    <div
      v-if="data.column.field === 'whiteListNames'"
      class="badges-container"
    >
      <b-badge
        v-for="(name, index) in visibleWhiteListNames"
        :key="'whiteList-' + index"
        class="mr-1"
      >
        {{ name }}
      </b-badge>
      <b-dropdown
        v-if="hiddenWhiteListNames.length"
        right
        class="badge-dropdown"
        no-caret
        variant="flat"
      >
        <template #button-content>
          •••
          <!-- <b-badge class="mr-1">+ {{ hiddenWhiteListNames.length }}</b-badge> -->
        </template>
        <b-dropdown-item
          v-for="(name, index) in hiddenWhiteListNames"
          :key="'whiteList-dropdown-' + index"
        >
          <b-badge>{{ name }}</b-badge>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div
      v-if="data.column.field === 'blackListNames'"
      class="badges-container"
    >
      <b-badge
        v-for="(name, index) in visibleBlackListNames"
        :key="'blackList-' + index"
        class="mr-1"
      >
        {{ name }}
      </b-badge>
      <b-dropdown
        v-if="hiddenBlackListNames.length"
        right
        class="badge-dropdown"
        no-caret
        variant="flat"
      >
        <template #button-content>
          •••
        </template>
        <b-dropdown-item
          v-for="(name, index) in hiddenBlackListNames"
          :key="'blackList-dropdown-' + index"
        >
          <b-badge>{{ name }}</b-badge>
        </b-dropdown-item>
      </b-dropdown>
      <span style="margin-left: auto;">
        <b-button
          variant="link"
          class="p-0"
          @click="deleteProperty(data.row)"
        >
          <GjIcon
            name="Delete"
            class="text-danger"
          />
        </b-button>
      </span>
    </div>
    <b-modal
      id="modal-small-delete"
      v-model="showModal"
      :ok-title="$tk('ClientPortal.Form.Actions.Delete')"
      :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$tk('ClientPortal.Admin.Delete')"
      no-enforce-focus
      @ok="triggerDelete"
    >
      <span>{{ "Are you sure you want to delete this property?" }}</span>
    </b-modal>
  </div>
</template>

<script>

import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import notification from '@/mixins/toastification'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      visibleCount: 3,
      propertyToDelete: null,
      showModal: false,
    }
  },
  computed: {
    visibleWhiteListNames() {
      return this.data.row.whiteListNames.slice(0, this.visibleCount)
    },
    hiddenWhiteListNames() {
      return this.data.row.whiteListNames.slice(this.visibleCount)
    },
    visibleBlackListNames() {
      return this.data.row.blackListNames.slice(0, this.visibleCount)
    },
    hiddenBlackListNames() {
      return this.data.row.blackListNames.slice(this.visibleCount)
    },
  },
  mounted() {
    this.calculateVisibleCount()
  },
  methods: {
    calculateVisibleCount() {
      this.visibleCount = this.calculateMaxVisibleBadges()
    },
    calculateMaxVisibleBadges() {
      return 3
    },
    deleteProperty(property) {
      this.propertyToDelete = property
      this.showModal = true
    },
    async triggerDelete() {
      await this.$store.dispatch('deleteProperty', this.propertyToDelete)
      this.success('Property Deleted')
      this.showModal = false // Close the modal
      this.propertyToDelete = null
    },
  },
}
</script>

<style lang="scss">
.badges-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100vh;
}
.badge-dropdown {
  height: 25px;
  width: 25px;
  background-color: #e0e5eb;
  border-radius: 100% !important;
  .btn.dropdown-toggle {
    font-size: 10px;
    font-weight: 400;
    height: 100%;
    width: 100%;
    padding: 1px;
    border-radius: 100%;
  }
}

</style>
